export default __webpack_public_path__ + "static/media/cost_reduction_support_1.dd827afd.png";